"use strict";

var NavigationEmitter = _interopRequireWildcard(require("makeup-navigation-emitter"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// REQUIRE
//const NavigationEmitter = require('makeup-navigation-emitter');

// IMPORT

const emitters = [];
const appender = document.getElementById("appender");
const widgetEls = document.querySelectorAll(".widget");
const wrapCheckbox = document.getElementById("wrap");
const log = e => console.log(e.type, e.detail);
const options = [{}, {
  autoInit: "none",
  autoReset: "none"
}, {
  autoInit: "none",
  autoReset: "none"
}];
appender.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const listEl = el.querySelector("ul");
    const listItem = document.createElement("li");
    listItem.innerText = `Item ${parseInt(listEl.querySelectorAll("li").length, 10)}`;
    listEl.appendChild(listItem);
  });
});
widgetEls.forEach(function (el, index) {
  el.addEventListener("navigationModelInit", log);
  el.addEventListener("navigationModelChange", log);
  el.addEventListener("navigationModelReset", log);
  el.addEventListener("navigationModelMutation", log);
  emitters.push(NavigationEmitter.createLinear(el, "li", options[index]));
});
wrapCheckbox.addEventListener("change", function (e) {
  emitters.forEach(function (emitter) {
    emitter.model.options.wrap = e.target.checked;
  });
});

// emitters[0].model.index = 1;
// emitters[1].model.index = 1;